import { render, staticRenderFns } from "./MessengerPanel.vue?vue&type=template&id=a2274af6&scoped=true"
import script from "./MessengerPanel.vue?vue&type=script&lang=js"
export * from "./MessengerPanel.vue?vue&type=script&lang=js"
import style0 from "./MessengerPanel.vue?vue&type=style&index=0&id=a2274af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2274af6",
  null
  
)

export default component.exports